// // // // // // // Default // // // // // // //
export const Kokkoro = {
  Dear_Idle: require("../assets/contact/default/Ranger_Kokkoro_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Ranger_Kokkoro_Greet.gif"),
};

export const Kyaru = {
  Dear_Idle: require("../assets/contact/default/Student_Kyaru_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Student_Kyaru_Greet.gif"),
};

export const Mifuyu = {
  Dear_Idle: require("../assets/contact/default/Work_Mifuyu_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Work_Mifuyu_Greet.gif"),
};

export const Ruka = {
  Dear_Idle: require("../assets/contact/default/Sarasalia_Ruka_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Sarasalia_Ruka_Greet.gif"),
};

export const Saren = {
  Dear_Idle: require("../assets/contact/default/Sarasalia_Saren_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Sarasalia_Saren_Greet.gif"),
};

export const Suzuna = {
  Dear_Idle: require("../assets/contact/default/Student_Suzuna_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Student_Suzuna_Greet.gif"),
};

export const Yukari = {
  Dear_Idle: require("../assets/contact/default/Camp_Yukari_Dear_Idle.gif"),
  Greet: require("../assets/contact/default/Camp_Yukari_Greet.gif"),
};


// // // // // // // New Year // // // // // // //
export const New_Year_Ruka = {
  Dear_Idle: require("../assets/contact/new_year/New_Year_Ruka_Dear_Idle.gif"),
  Greet: require("../assets/contact/new_year/New_Year_Ruka_Greet.gif"),
};


// // // // // // // Summer // // // // // // //
export const Summer_Kokkoro = {
  Dear_Idle: require("../assets/contact/summer/Summer_Kokkoro_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Kokkoro_Greet.gif"),
};

export const Summer_Kyaru = {
  Dear_Idle: require("../assets/contact/summer/Summer_Kyaru_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Kyaru_Greet.gif"),
};

export const Summer_Mifuyu = {
  Dear_Idle: require("../assets/contact/summer/Summer_Mifuyu_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Mifuyu_Greet.gif"),
};

export const Summer_Ruka = {
  Dear_Idle: require("../assets/contact/summer/Summer_Ruka_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Ruka_Greet.gif"),
};

export const Summer_Saren = {
  Dear_Idle: require("../assets/contact/summer/Summer_Saren_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Saren_Greet.gif"),
};

export const Summer_Suzuna = {
  Dear_Idle: require("../assets/contact/summer/Summer_Suzuna_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Suzuna_Greet.gif"),
};

export const Summer_Yukari = {
  Dear_Idle: require("../assets/contact/summer/Summer_Yukari_Dear_Idle.gif"),
  Greet: require("../assets/contact/summer/Summer_Yukari_Greet.gif"),
};


// // // // // // // Halloween // // // // // // //
export const Halloween_Rei = {
  Dear_Idle: require("../assets/contact/halloween/Halloween_Rei_Dear_Idle.gif"),
  Greet: require("../assets/contact/halloween/Halloween_Rei_Greet.gif"),
};


// // // // // // // Christmas // // // // // // //
export const Christmas_Saren = {
  Dear_Idle: require("../assets/contact/christmas/Christmas_Saren_Dear_Idle.gif"),
  Greet: require("../assets/contact/christmas/Christmas_Saren_Greet.gif"),
};
